import React from "react";
import { observer } from "mobx-react";
import { TenantTypeViewStore } from "../../store";
import { TenantTypeViewForm } from "./TenantTypeViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type TenantTypeViewProps = {
  tenantTypeViewStore: TenantTypeViewStore;
};

export const TenantTypeView: React.FC<TenantTypeViewProps> = observer(
  ({ tenantTypeViewStore }) => {
    return (
      <div>
        <TenantTypeViewForm
          name_es={tenantTypeViewStore.name_esValue}
          name_en={tenantTypeViewStore.name_enValue}
          name_pt={tenantTypeViewStore.name_ptValue}
          description_es={tenantTypeViewStore.description_esValue}
          description_en={tenantTypeViewStore.description_enValue}
          description_pt={tenantTypeViewStore.description_ptValue}
          onPrint={(handlePrint: () => void) =>
            tenantTypeViewStore.printTenantType(handlePrint)
          }
          onCancel={() => tenantTypeViewStore.cancelTenantType()}
          onEdit={
            tenantTypeViewStore.isEditEnabled
              ? () => tenantTypeViewStore.editTenantType()
              : undefined
          }
        />
        <ErrorDialog
          open={tenantTypeViewStore.errorDialogOpened}
          title={tenantTypeViewStore.errorTitle}
          description={tenantTypeViewStore.errorDescription}
          onClose={() => tenantTypeViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
